import { AulaEntity } from '../Entities';

export const hasFailedUpload = (aulaEntity: AulaEntity) =>
  aulaEntity.type === 'file' && !!aulaEntity.failed;
